export default "__VITE_ASSET__BpAA3P83__"